import { FormattedMessage } from '@futrli/localisation';
import React from 'react';
import Icon from 'carbon-react/lib/components/icon';

import { InformativeDatasourceStatusMessage } from '../informative-datasource-status-message/informative-datasource-status-message';

const WorkspaceStatusPendingFC: React.FC = () => (
  <InformativeDatasourceStatusMessage
    icon={<Icon type="warning" fontSize="extra-large" />}
    title={
      <FormattedMessage id="predict.something_lost" defaultMessage="Looks like something got lost along the way!" />
    }
    body={
      <FormattedMessage
        id="predict.contact_support_activate_subscription"
        defaultMessage="Please contact customer support to activate your subscription."
      />
    }
    showContactSupport={true}
  />
);
export const WorkspaceStatusPending = React.memo(WorkspaceStatusPendingFC);
